<script lang="ts">
    import { onMount } from 'svelte'
    import DateSelect from '../../_common/date-select.svelte'
    import { GridButton, GridClass, GridCol, GridColTypeEnum, GridLine } from '../../_common/z/zgrid'
    import Grid from '../../_common/z/zgrid.svelte'
    import type { Invoice } from '../../../modules/posApi/invoices/invoice'
    import LoadSpinner from '../../_common/load-spinner.svelte'
    import { faUser } from '@fortawesome/free-solid-svg-icons'

    let dateSelect: { from: Date; to: Date } = window.api.utils.dates.today()

    onMount(() => {
        load(dateSelect.from, dateSelect.to)
    })

    let show = false

    let grid: GridClass = null
    async function load(from: Date, to: Date) {
        if (show) return
        show = true
        let data: Invoice[] = await window.api.pos.invoices.getAll({ from, to })
        data = await window.api.utils.utils.assignPersonsFromObject(data)
        console.log('relat.data', data)
        grid = new GridClass()
        grid.title = 'Pessoas que realizaram uma compra'
        //grid.subtitle = 'Período de ' + dayjs(from).format('DD/MM/YYYY') + ' até ' + dayjs(to).format('DD/MM/YYYY')
        grid.cols.push(new GridCol({ content: 'Data', type: GridColTypeEnum.datetime }))
        grid.cols.push(new GridCol({ content: 'Cliente' }))
        grid.cols.push(new GridCol({ content: 'Telefone', type: GridColTypeEnum.phone }))
        grid.cols.push(new GridCol({ content: 'Valor comprado', type: GridColTypeEnum.float_2 }))
        grid.cols.push(new GridCol({ content: 'Valor pago', type: GridColTypeEnum.float_2 }))
        grid.cols.push(new GridCol({ type: GridColTypeEnum.button }))
        for (const item of data) {
            const btnEdit = new GridButton({
                callback: () => window.person('show', item.personId),
                icon: faUser,
            })
            let line: GridLine = new GridLine()
            line.slots.push({ content: item.createdAt })
            line.slots.push({ content: item['person']?.name })
            line.slots.push({ content: item['person']?.phone })
            line.slots.push({ content: item.total })
            line.slots.push({ content: item.totalPaid })
            line.slots.push({ content: [btnEdit] })
            grid.lines.push(line)
        }
        console.log('relat.grid', grid)
        show = false
    }

    function dateChanged(event) {
        dateSelect = event.detail
        load(dateSelect.from, dateSelect.to)
    }
</script>

<div class="relat-body">
    <div class="acts h-print">
        <div class="date">
            <DateSelect on:change={dateChanged} />
        </div>
    </div>
    <div class="grid mt-2">
        <Grid {grid} />
    </div>
</div>
<LoadSpinner {show}></LoadSpinner>
